import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { images } from '../data/village-data';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/life-map');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="login-page" className="auth-page" style={{
      backgroundImage: `linear-gradient(rgba(15,10,25,0.7), rgba(15,10,25,0.85)), url(${images.treeOfLife})`,
    }}>
      <div className="auth-card">
        <h1 className="auth-title">Welcome Back</h1>
        <p className="auth-subtitle">Enter the Village</p>

        {error && <p data-testid="login-error" className="auth-error">{error}</p>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            data-testid="login-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />
          <input
            data-testid="login-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-input"
          />
          <button data-testid="login-submit" type="submit" className="village-btn village-btn--primary auth-submit" disabled={loading}>
            {loading ? 'Entering...' : 'Enter'}
          </button>
        </form>

        <p className="auth-switch">
          New to the Village? <Link to="/register" className="auth-link">Create your Manifestor profile</Link>
        </p>
        <Link to="/life-map" className="auth-skip">Continue as guest</Link>
      </div>
    </section>
  );
}
